<template>
  <elements-layout
          :extra-filters="extraFilters"
          :table-columns='tableColumns'
          :fetch-data-url='fetchDataUrl'

          :tableRepresentation="true"

          :store-module-name="STORE_MODULE_NAME"
          :store-module-config="STORE_MODULE_CONFIG"

          :addDataSidebarAvailable="$can('create', 'bridge')"

  >

    <template #addDataForm>
      <bridge-add-update></bridge-add-update>
    </template>

    <template #tableCellCustomRepresentations="cell">

        <template v-if="cell.field.key === 'bridge'">
            <template v-if="get(cell.item, 'id')">
                <bridge-cell :data="cell.item"></bridge-cell>
            </template>
            <template v-else>
                {{cell.item}}
            </template>
        </template>
        <template v-else-if="cell.field.key === 'platform'">
            <template v-if="get(cell.value, 'id')">
                <platform-cell :data="cell.value"></platform-cell>
            </template>

        </template>
        <template v-else-if="cell.field.key === 'station'">
            <template v-if="get(cell.value, 'id')">
                <station-cell :data="cell.value"></station-cell>
            </template>

        </template>
        <template v-else-if="cell.field.key === 'sector'">
            <template v-if="get(cell.value, 'id')">
                <bridge-cell :data="cell.value"></bridge-cell>
            </template>

        </template>
        <template v-else-if="cell.field.key === 'railway'">
            <template v-if="get(cell.value, 'id')">
                <railway-cell :data="cell.value"></railway-cell>
            </template>

        </template>

        <template v-else-if="cell.field.key === 'user'">
            <template v-if="get(cell.value, 'id')">
                <user-cell :user="cell.value"></user-cell>
            </template>

        </template>
    </template>

  </elements-layout>
</template>

<script>

  import ElementsLayout from '@core/components/app-elements/AppElementsLayout.vue'

  import {STORE_MODULE_NAME, STORE_MODULE_CONFIG} from '../bridgeStoreModule'
  import useBridge from '../useBridge'

  import BridgeAddUpdate from '../components/BridgeAddUpdate'

  import get from 'lodash.get'

  import UserCell from "@/views/apps/user/components/UserCell";

  import BridgeCell from "@/views/apps/railway_structure/bridge/components/BridgeCell";
    import StationCell from "@/views/apps/railway_structure/station/components/StationCell";

  import SectorCell from "@/views/apps/railway_structure/sector/components/SectorCell";
  import RailwayCell from "@/views/apps/railway_structure/railway/components/RailwayCell";
  import PlatformCell from "@/views/apps/railway_structure/platform/components/PlatformCell";

  export default {
    props: {
      // Фильтр приходит из карточки родителя: список внутри вкладки обязан
      // показывать только подчинённые записи, а не всё подряд
      extraFilters: {
        type: Object,
        default: () => ({}),
        required: false,
      },
    },
    components: {
        PlatformCell,
        RailwayCell,
        UserCell,
        SectorCell,
        StationCell,
      BridgeCell,
      ElementsLayout,
      BridgeAddUpdate,
    },
    setup() {

      const {

        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

      } = useBridge();

      return {
        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

        STORE_MODULE_NAME,
        STORE_MODULE_CONFIG,

        get,
      }
    },
  }
</script>
